import { ButtonHTMLAttributes } from 'react';
import { Spinner } from 'react-bootstrap';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    children: string;
    type: 'button' | 'submit' | 'reset';
    isActive: boolean;
}

export function Button({ children, type, isActive, ...rest }: ButtonProps) {

    return isActive ? (
        <button type={type} disabled {...rest}>
            <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
            />
            <span>Carregando...</span>
        </button >
    ) : (
        <button type={type} {...rest}>
            {children}
        </button>
    )
}
